import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import home from '../components/home.vue'
import index from '../components/index.vue'
import versionUpdate from '../utils/versionUpdate'


/**
 * 路由配置
 */

// 1.声明视图

// 2.定义路由

const routes = [
  {
    path: '/',
    name: 'index',
    component: index,
    children: [
      {
        path: 'about',
        name: 'about',
        component: () => import(/* webpackChunkName: "home" */ '../components/about.vue')
      },
      {
        path: '',
        name: 'home',
        component: home
      },
      {
        path: 'code_of_conduct',
        name: 'code_of_conduct',
        component: () => import(/* webpackChunkName: "home" */ '../components/code_of_conduct.vue')
      },
      {
        path: 'atomic_api_example',
        name: 'atomic_api_example',
        component: () => import(/* webpackChunkName: "v4" */ '../components/atomic_api_example.vue')
      },
      {
        path: 'int_api',
        name: 'int_api',
        component: () => import(/* webpackChunkName: "v4" */ '../components/int_api.vue')
      },
      {
        path: 'uint_api',
        name: 'uint_api',
        component: () => import(/* webpackChunkName: "v4" */ '../components/uint_api.vue')
      },
      {
        path: 'boolfloat_api',
        name: 'boolfloat_api',
        component: () => import(/* webpackChunkName: "v4" */ '../components/boolfloat_api.vue')
      },
      {
        path: 'bytearray_api',
        name: 'bytearray_api',
        component: () => import(/* webpackChunkName: "v4" */ '../components/bytearray_api.vue')
      },
      {
        path: 'atomic_shared_memory',
        name: 'atomic_shared_memory',
        component: () => import(/* webpackChunkName: "v4" */ '../components/atomic_shared_memory.vue')
      },
      {
        path: 'shared_dict',
        name: 'shared_dict',
        component: () => import(/* webpackChunkName: "v4" */ '../components/shared_dict.vue')
      },
      {
        path: 'atomic_object_backend',
        name: 'atomic_object_backend',
        component: () => import(/* webpackChunkName: "v4" */ '../components/atomic_object_backend.vue')
      },

      {
        path: 'v2/int_api',
        name: 'v2_int_api',
        component: () => import(/* webpackChunkName: "v2" */ '../components/v2/int_api.vue')
      },
      {
        path: 'v2/uint_api',
        name: 'v2_uint_api',
        component: () => import(/* webpackChunkName: "v2" */ '../components/v2/uint_api.vue')
      },
      {
        path: 'v2/boolfloat_api',
        name: 'v2_boolfloat_api',
        component: () => import(/* webpackChunkName: "v2" */ '../components/v2/boolfloat_api.vue')
      },
      {
        path: 'v2/bytearray_api',
        name: 'v2_bytearray_api',
        component: () => import(/* webpackChunkName: "v2" */ '../components/v2/bytearray_api.vue')
      },
      {
        path: 'v2/list_api',
        name: 'v2_list_api',
        component: () => import(/* webpackChunkName: "v2" */ '../components/v2/list_api.vue')
      },
      {
        path: 'v2/set_api',
        name: 'v2_set_api',
        component: () => import(/* webpackChunkName: "v2" */ '../components/v2/set_api.vue')
      },
      {
        path: 'v2/string_api',
        name: 'v2_string_api',
        component: () => import(/* webpackChunkName: "v2" */ '../components/v2/string_api.vue')
      },
      {
        path: 'v2/atomic_shared_memory',
        name: 'v2_atomic_shared_memory',
        component: () => import(/* webpackChunkName: "v2" */ '../components/v2/atomic_shared_memory.vue')
      },
      {
        path: 'v2/atomic_object',
        name: 'atomic_object2',
        component: () => import(/* webpackChunkName: "v2" */ '../components/v2/atomic_object.vue')
      },

      {
        path: 'v3/int_api',
        name: 'v3_int_api',
        component: () => import(/* webpackChunkName: "v3" */ '../components/v3/int_api.vue')
      },
      {
        path: 'v3/uint_api',
        name: 'v3_uint_api',
        component: () => import(/* webpackChunkName: "v3" */ '../components/v3/uint_api.vue')
      },
      {
        path: 'v3/boolfloat_api',
        name: 'v3_boolfloat_api',
        component: () => import(/* webpackChunkName: "v3" */ '../components/v3/boolfloat_api.vue')
      },
      {
        path: 'v3/bytearray_api',
        name: 'v3_bytearray_api',
        component: () => import(/* webpackChunkName: "v3" */ '../components/v3/bytearray_api.vue')
      },
      {
        path: 'v3/list_api',
        name: 'v3_list_api',
        component: () => import(/* webpackChunkName: "v3" */ '../components/v3/list_api.vue')
      },
      {
        path: 'v3/set_api',
        name: 'v3_set_api',
        component: () => import(/* webpackChunkName: "v3" */ '../components/v3/set_api.vue')
      },
      {
        path: 'v3/string_api',
        name: 'v3_string_api',
        component: () => import(/* webpackChunkName: "v3" */ '../components/v3/string_api.vue')
      },
      {
        path: 'v3/atomic_shared_memory',
        name: 'v3_atomic_shared_memory',
        component: () => import(/* webpackChunkName: "v3" */ '../components/v3/atomic_shared_memory.vue')
      },
      {
        path: 'v3/atomic_object',
        name: 'v3_atomic_object',
        component: () => import(/* webpackChunkName: "v3" */ '../components/v3/atomic_object.vue')
      },

      {
        path: 'atomic_tools',
        name: 'atomic_tools',
        component: () => import(/* webpackChunkName: "v4" */ '../components/atomic_tools.vue')
      },
      {
        path: 'atomic_api_example',
        name: 'atomic_api_example',
        component: () => import(/* webpackChunkName: "v4" */ '../components/atomic_api_example.vue')
      },
      {
        path: 'payment',
        name: 'payment',
        component: () => import(/* webpackChunkName: "home" */ '../components/payment.vue')
      },
      {
        path: 'wechat_payment_finished',
        name: 'wechat_payment_finished',
        component: () => import(/* webpackChunkName: "home" */ '../components/wechat_payment_finished.vue')
      },
      {
        path: 'paypal_payment_finished',
        name: 'paypal_payment_finished',
        component: () => import(/* webpackChunkName: "home" */ '../components/paypal_payment_finished.vue')
      },
      {
        path: 'enterprise_service',
        name: 'enterprise_service',
        component: () => import(/* webpackChunkName: "home" */ '../components/enterprise_service.vue')
      },
      {
        path: 'gitee',
        name: 'gitee',
        // 用meta传递外部链接的信息
        meta: {
          is_external: true,
          external_url: 'https://gitee.com/irvinren/shared_atomic_enterprise' 
        }
      },
      
    ]
  },
,


]

// 3.创建路由对象

let router = null;
if (!(process.env.CORDOVA_PLATFORM == undefined) || !(process.env.IS_ELECTRON == undefined)) {
  router = createRouter({
    history: createWebHashHistory(),
    routes
  })
}
else {
  router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
  })
}

// 跳转之前被调用，全局！！！


router.beforeEach((to, from, next) => {


  if (typeof cordova === "undefined") {
    next();
    versionUpdate.isNewVersion()
  }
  if (to.meta.is_external) {
    // 跳转到外部URL
    window.location.href = to.meta.external_url;
    // 阻止Vue Router继续处理这个“内部路由”（因为实际要跳外部）
    next(false);
  }
  else {
    next(); // 正常处理内部路由
  }
})

export default router
